import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Col, Row, Selection } from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import { Field } from 'react-final-form';
import { FaCog } from 'react-icons/fa';
import SettingsCardWrapper from './SettingsCardWrapper';
import css from '../../styles.css';

function BasicSettingsCard({ loanTypeOptions, pending }) {
  return (
    <SettingsCardWrapper
      titleId="ui-plugin-inventory-templates.templatesOtherSettings.sections.basicSettings"
      defaultTitle="Basic Settings"
      icon={FaCog}
    >
      <Row>
        <Col xs={12}>
          <Field
            id="allowCreateEmptyInstance"
            name="basicSettings.allowCreateEmptyInstance"
            component={Checkbox}
            fullWidth
            label={
              <FormattedMessage
                id="ui-plugin-inventory-templates.templatesOtherSettings.fields.allowCreateEmptyInstance"
                defaultMessage="Allow save instance without holdings or items"
              />
            }
            type="checkbox"
            onMouseDown={(e) => e.preventDefault()}
          />
        </Col>
        <Col className={css.infoMsg} style={{ fontSize: '14px' }}>
          <FormattedMessage
            id="ui-plugin-inventory-templates.templatesOtherSettings.fields.allowCreateEmptyInstance.info"
            defaultMessage="When this option checked, the cataloger can be able to create new or edit instance without adding any holdings or items"
          />
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <Field
            id="allowImportEmptyInstance"
            name="basicSettings.allowImportEmptyInstance"
            component={Checkbox}
            fullWidth
            label={
              <FormattedMessage
                id="ui-plugin-inventory-templates.templatesOtherSettings.fields.allowImportEmptyInstance"
                defaultMessage="Allow import instance without holdings or items"
              />
            }
            type="checkbox"
            onMouseDown={(e) => e.preventDefault()}
          />
        </Col>
        <Col className={css.infoMsg} style={{ fontSize: '14px' }}>
          <FormattedMessage
            id="ui-plugin-inventory-templates.templatesOtherSettings.fields.allowImportEmptyInstance.info"
            defaultMessage="When this option checked, the cataloger can be able to import instance from external sources without adding any holdings or items"
          />
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <Field
            id="firstItemLoanPolicy"
            name="basicSettings.firstItemLoanPolicy"
            component={Selection}
            fullWidth
            label={
              <FormattedMessage
                id="ui-plugin-inventory-templates.templatesOtherSettings.fields.firstItemLoanPolicy"
                defaultMessage="Loan policy for first item/copy"
              />
            }
            placeholder={
              <FormattedMessage
                id="ui-plugin-inventory-templates.templatesOtherSettings.fields.firstItemLoanPolicy.placeholder"
                defaultMessage="Select loan policy"
              />
            }
            dataOptions={loanTypeOptions}
            loading={pending}
            disabled={pending}
          />
        </Col>
        <Col className={css.infoMsg} style={{ fontSize: '14px' }}>
          <FormattedMessage
            id="ui-plugin-inventory-templates.templatesOtherSettings.fields.firstItemLoanPolicy.info"
            defaultMessage="Select the loan policy to be automatically applied to the first item/copy in each holding. This ensures at least one copy of each title remains available by applying the selected circulation policy automatically."
          />
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <Field
            id="enableRecordLocking"
            name="basicSettings.enableRecordLocking"
            component={Checkbox}
            fullWidth
            label={
              <FormattedMessage
                id="ui-plugin-inventory-templates.templatesOtherSettings.fields.enableRecordLocking"
                defaultMessage="تفعيل نظام قفل التسجيلات"
              />
            }
            type="checkbox"
            onMouseDown={(e) => e.preventDefault()}
          />
        </Col>
        <Col className={css.infoMsg} style={{ fontSize: '14px' }}>
          <FormattedMessage
            id="ui-plugin-inventory-templates.templatesOtherSettings.fields.enableRecordLocking.info"
            defaultMessage="عند تفعيل هذا الخيار، سيتم منع المستخدمين الآخرين من تحرير نفس التسجيلة في نفس الوقت لتجنب تضارب البيانات"
          />
        </Col>
      </Row>
    </SettingsCardWrapper>
  );
}

BasicSettingsCard.propTypes = {
  loanTypeOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  pending: PropTypes.bool.isRequired,
};

export default BasicSettingsCard;
